import React from "react";
import type { RouteObject } from "react-router-dom";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { RecommendationCampaignResource } from "@exonn/js-sdk";
import { RecommendationCampaignFormTabs } from "src/admin/modules/recommendation-campaign/constants.ts";

const audienceRoute: RouteObject = {
  lazy: () =>
    import(
      "src/admin/modules/recommendation-campaign/routes/edit/tabs/audience/audience.route.tsx"
    ),
};

const upliftRoute: RouteObject = {
  lazy: () =>
    import(
      "src/admin/modules/recommendation-campaign/routes/edit/tabs/uplift/uplift.route.tsx"
    ),
};

/**
 * Recommendation campaigns — the recommendation-side layer on top of a
 * marketing campaign. Created and edited here; the audience and the uplift
 * live on their own tabs.
 *
 * Удаление разрешено, но только до рассылки — запрет держит бэкенд той же
 * границей, что запирает поля (`frozenReason`). Раньше оно было закрыто
 * наглухо, с доводом «кампания несёт аудиторию, конверсии и рандомизацию».
 * Довод верен ровно после отправки: до неё конверсий нет по определению
 * (их пишут от даты первого контакта), кулдаун ещё не проставлен, а раскладка
 * по плечам воспроизводится из зерна. Оставались только черновики, которые
 * нечем было убрать.
 */
export const module: ModuleOptions<RecommendationCampaignResource> = {
  resource: ResourceEnum.RecommendationCampaign,
  bigIcon: <i className="icon-20-marketing" />,
  smallIcon: <i className="icon-15-market_comp" />,
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
  formTabs: {
    [RecommendationCampaignFormTabs.General]: {
      title: (t) => t("formTabs.general.title"),
    },
    [RecommendationCampaignFormTabs.Audience]: {
      title: (t) => t("formTabs.audience.title"),
      routeObject: audienceRoute,
    },
    [RecommendationCampaignFormTabs.Uplift]: {
      title: (t) => t("formTabs.uplift.title"),
      routeObject: upliftRoute,
    },
  },
};
